
  <div class="row cout">
    <div class="col-md-6 cursorHelp"  title="Repas : {{libelleRepas.toUpperCase()}}" >COÛT UNITAIRE PONDÉRÉ</div>
    <div class="col-md-6 text-right">
      <span class="cursorHelp"  [title]="getInfoCoutUnitaire(libelleRepas,coutRepas,coutTheoriqueRepas)">{{coutRepas | currency:'EUR':'symbol':'1.4-4' }}</span>
    </div>
  </div>

